//prefix--子项目前缀
//localEntry--本地entry
//obsEntry--华为云entry
export const subApps = [
    {
        prefix: 'tenant',
        localEntry: '//tenant.grtcloud.net/',
        obsEntry: '/tenant-alias/'
    },
    {
        prefix: 'manage',
        localEntry: '//manage.grtcloud.net/',
        obsEntry: '/manage-alias/'
    },
    {
        prefix: 'base',
        localEntry: '//base.grtcloud.net/',
        obsEntry: '/base-alias/'
    },
    {
        prefix: 'evaluation',
        localEntry: '//evaluation.grtcloud.net/',
        obsEntry: '/evaluation-alias/'
    },
    {
        prefix: 'app',
        localEntry: '//app.grtcloud.net/',
        obsEntry: '/app-management/'
    }
];
